import React from 'react';
import moment from 'moment';
import { MomentDateFormat } from '../MomentDateFormat';

export default class BrokerCapacityDisplayText extends React.Component {
    render() {
        const {
            brokerDefaultCapacity,
            brokerDateCapacities,
            date,
            brokerCapacityOverview,
        } = this.props;

        if (brokerCapacityOverview) {
            const indicatedDate = moment(brokerCapacityOverview.date).format(
                MomentDateFormat.DateOnlyUTCSlashes
            );
            const { activeAssignmentCount, maximumAssignmentCount } =
                brokerCapacityOverview;

            return (
                <>
                    {indicatedDate} - {activeAssignmentCount} assignments (
                    {maximumAssignmentCount} max)
                </>
            );
        }

        const displayDate = moment(date).format(
            MomentDateFormat.DateOnlyUTCSlashes
        );

        const selectedDateCapacity = brokerDateCapacities.find((bdc) =>
            moment(date).isSame(bdc.date, 'day')
        );

        if (selectedDateCapacity) {
            return (
                <>
                    {displayDate} - up to{' '}
                    {selectedDateCapacity.maximumAssignmentCount} assignments
                    max.
                </>
            );
        }

        return (
            <>
                Default - up to {brokerDefaultCapacity.maximumAssignmentCount}{' '}
                assignments max.
            </>
        );
    }
}
